import React from 'react';
import { connect } from 'react-redux';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { featureSelector } from '../../../redux/reducers/feature.selector.js';
import { setFlags } from '../../../redux/actions/feature.action.js';

const Feature = ({ setFlags, feature, id }) => {
  const handleChange = event => {
    setFlags({
      id,
      ...feature,
      [event.target.name]: event.target.checked ? 1 : 0
    });
  };

  return (
    <FormGroup row>
      <FormControlLabel
        control={
          <Checkbox
            checked={feature.notax === 1 ? true : false}
            onChange={handleChange}
            name="notax"
            color="primary"
          />
        }
        label={
          <h6>
            звільнення від сплати єдиного внеску на загальнообов’язкове
            соціальне страхування (пенсіонер, особа з інвалідністю)
          </h6>
        }
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={feature.registered === 1 ? true : false}
            onChange={handleChange}
            name="registered"
            color="primary"
          />
        }
        label={
          <h6>державна реєстрація фізичної особи у січні-березні 2020 року</h6>
        }
      />
    </FormGroup>
  );
};

const mapStateToProps = state => ({
  feature: featureSelector(state),
  id: state.applicant.id
});

export default connect(mapStateToProps, { setFlags })(Feature);
